import {DomainObject} from 'shared/store';
import {observable, computed} from 'mobx';

class SurveyQuestionOption extends DomainObject {
  @observable title;
  @observable label;
  @observable order;

  @computed get color() {
    if (this.order < 2) {
      return '#F64A6C';
    } else if (this.order < 3) {
      return '#F4AC29';
    } else {
      return '#80D137';
    }
  }
}

export default SurveyQuestionOption;
